import Device from "../devices/device";

//Función por defecto para comprobar si un texto es una URL válida
const checkURLDefault = (texto) => {
  try {
    new URL(texto);
    return true;
  } catch (e) {
    return false;
  }
}

//Función que dice si el dispositivo es uno de los que necesita una comprobación alternativa
const isAlternativeDevice = () => {
  const devicesAlternatives = ['ps4'];
  const devicePlatform = Device.getDevice().getPlatform();

  return devicesAlternatives.includes(devicePlatform);
}

//Función alternativa para comprobar si un texto es una URL válida
const alternativeCheckURL = (texto) => {

  if (!texto || typeof texto !== 'string') {
    return false;
  }

  const urlPattern = /^https?:\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-.~:/?#[\]@!$&'()*+,;=%]*)?$/i;

  return urlPattern.test(texto.trim());
}

//Función principal que decide qué método usar para comprobar si un texto es una URL válida
export const isValidURL = (texto) => {
  const useAlternativeFunction = isAlternativeDevice();
  return useAlternativeFunction ? alternativeCheckURL(texto) : checkURLDefault(texto);
};



// WEBPACK FOOTER //
// ./src/utils/isValidURL.js